import { accessGateConstants } from './constants';

export const openAccessGate = (payload = {}) => ({
    type: accessGateConstants.ACCESS_GATE_OPEN,
    payload,
});

export const closeAccessGate = () => ({
    type: accessGateConstants.ACCESS_GATE_CLOSE,
});

export const clearAccessGate = () => ({
    type: accessGateConstants.ACCESS_GATE_CLEAR,
});

export const patchAccessGate = (payload = {}) => ({
    type: accessGateConstants.ACCESS_GATE_PATCH,
    payload,
});
